{
  "newAnnouncement": "Hat eine neue Ankündigung",
  "notification": "Benachrichtigungen und Ankündigungen",
  "unread": "Ungelesene Benachrichtigungen"
}
